import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Row, Input, Label, FormGroup, Form } from 'reactstrap';
import {
  approveDealer,
  rejectDealer,
  modifyDealer,
  saveForApprovalDealer,
} from '../../constants/apiCalls';
import { Roles } from '../../constants/Roles';
import ModalService from '../../services/ModalService';
import Storage from '../../services/Storage';
import { handleErrorMessage } from '../../utils/utils';
import { CommonButton } from '../CommonComponents';
import './index.css';

const ApplicationApproval = ({ userId, previewData }) => {
  const [currentRadioValue, setCurrentRadioValue] = useState('');
  const [remarks, setRemarks] = useState('');
  const navigate = useNavigate();
  let userInfo = Storage.getUserInfoDetail();
  let roleName = userInfo ? userInfo.role: '';

  let uniqueRemark =
    previewData.remarks &&
    (previewData.remarks !== null || previewData.remarks !== 'undefined')
      ? previewData.remarks.filter(
          (text, index) =>
            index ===
            previewData.remarks.findIndex(
              (other) =>
                text.remark === other.remark &&
                text.action_by === other.action_by &&
                text.role === other.role
            )
        )
      : [];
  const handleSumbit = (evt) => {
    evt.preventDefault();
    let payload = {
      dealer_id: parseInt(userId),
      remark: remarks,
    };
    if (currentRadioValue === 'accept application') {
      if (roleName === Roles.NH_NAME) {
        approveDealer((res) => {
          const { success, message, error } = res;
          if (success === true) {
            ModalService.openAlert('', message, 'success');
            setTimeout(() => {
              navigate(
                `/pages/pipeline/${userId}`
              );
            }, 3000);
          } else if(success === false || success === 'undefined') {
            ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          }
        }, payload);
      } else if (roleName === Roles.SH_NAME) {
        saveForApprovalDealer((res) => {
          const { success, message, error } = res;
          if (success === true) {
            ModalService.openAlert('', message, 'success');
            setTimeout(() => {
              navigate(
                `/pages/pipeline/${userId}`
              );
            }, 3000);
          } else if(success === false || success === 'undefined') {
            ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          }
        }, payload);
      }
    } else if (currentRadioValue === 'reject application') {
      rejectDealer((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setTimeout(() => {
            navigate(
              `/pages/pipeline/${userId}`
            );
          }, 3000);
        } else if(success === false || success === 'undefined') {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
      }, payload);
    } else {
      modifyDealer((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setTimeout(() => {
            navigate(
              `/pages/pipeline/${userId}`
            );
          }, 3000);
        } else if(success === false || success === 'undefined') {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
      }, payload);
    }
  };

  return (
    <div id='ApplicationApproval'>
      <Row>
        <Col xs={12}>
          <div className='d-flex align-items-center titleBlock'>
            <div className='common-title'>Application Approval</div>
          </div>
        </Col>
      </Row>
      <Row>
        <>
          {uniqueRemark.length > 0 &&
            uniqueRemark.filter((elem) => elem.role === Roles.NH_NAME).length >
              0 && (
              <Col xs={12} className='mb-1'>
                <div className='d-flex'>
                  <span>
                    {uniqueRemark.length > 0 &&
                      uniqueRemark
                        .filter((elem) => elem.role === Roles.NH_NAME)
                        .map((elem, index) => {
                          return (
                            <div key={index}>
                              <span className='remarks-title pl-3 pr-3'>
                                Confirmation Note from NH
                              </span>
                              <span>{elem.remark}</span> <br />
                            </div>
                          );
                        })}
                  </span>
                </div>
              </Col>
            )}
          {uniqueRemark.length > 0 &&
            uniqueRemark.filter((elem) => elem.role === Roles.SH_NAME).length >
              0 && (
              <Col xs={12} className='mb-1'>
                <div className='d-flex'>
                  <span>
                    {uniqueRemark.length > 0 &&
                      uniqueRemark
                        .filter((elem) => elem.role === Roles.SH_NAME)
                        .map((elem, index) => {
                          return (
                            <div key={index}>
                              <span className='remarks-title pl-3 pr-3'>
                                Confirmation Note from SH
                              </span>
                              <span>{elem.remark}</span> <br />
                            </div>
                          );
                        })}
                  </span>
                </div>
              </Col>
            )}
          {uniqueRemark.length > 0 &&
            uniqueRemark.filter((elem) => elem.role === Roles.TM_NAME)
              .length > 0 && (
              <Col xs={12} className='mb-1'>
                <div className='d-flex'>
                  <span>
                    {uniqueRemark.length > 0 &&
                      uniqueRemark
                        .filter((elem) => elem.role === Roles.TM_NAME)
                        .map((elem, index) => {
                          return (
                            <div key={index}>
                              <span className='remarks-title pl-3 pr-3'>
                                Confirmation Note from TM
                              </span>
                              <span>{elem.remark}</span> <br />
                            </div>
                          );
                        })}
                  </span>
                </div>
              </Col>
            )}
        </>
      </Row>
      <Row>
        <Col xs={12}>
          <h5 className='remarks-title pl-3 mt-2'>Action</h5>
        </Col>
      </Row>
      <Form onSubmit={handleSumbit} className='pl-3 pr-3'>
        <Row className='pl-3'>
          <Col xs={4} lg={2}>
            <FormGroup>
              <Input
                type='radio'
                required
                value={'accept application'}
                onChange={(e) => setCurrentRadioValue(e.target.value)}
                name='status'
              ></Input>
              <Label>Accept Application</Label>
            </FormGroup>
          </Col>
          <Col xs={4} lg={2}>
            <FormGroup>
              <Input
                type='radio'
                required
                value={'modification'}
                onChange={(e) => setCurrentRadioValue(e.target.value)}
                name='status'
                size={'50px'}
              ></Input>
              <Label>Modification</Label>
            </FormGroup>
          </Col>
          <Col xs={4} lg={2}>
            <FormGroup>
              <Input
                type='radio'
                value={'reject application'}
                required
                onChange={(e) => setCurrentRadioValue(e.target.value)}
                name='status'
              ></Input>
              <Label>Reject Application</Label>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={1}>
            <h5 className='remarks-title'>Remarks</h5>
          </Col>
          <Col xs={11}>
            <Input
              type='textarea'
              name='confirmNote'
              className='address-area w-100'
              required
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              placeholder='Enter Your Remarks'
              rows='3'
            ></Input>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className='text-center'>
            <CommonButton name={'Submit'} btnClass={'btnPrimary'} type="submit" />
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default React.memo(ApplicationApproval);
